import { alpha, Menu, MenuProps, styled } from "@mui/material";

export const StyledMenu = styled((props: MenuProps & { position?: 'top' | 'bottom' }) => {
    const { position = 'bottom', ...otherProps } = props;

    return (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: position === 'top' ? 'top' : 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: position === 'top' ? 'bottom' : 'top',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    sx: {
                        mt: position === 'bottom' ? 1 : 0,
                        mb: position === 'top' ? 1 : 0,
                        ml: "-1px"
                    },
                },
            }}
            {...otherProps}
        />
    );
})(({ theme, position }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: position === 'top' ? theme.spacing(-1) : theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
            '&.Mui-disabled': {
                cursor: 'not-allowed',
            },
        },
    },
}));